import CopyResult from "./CopyResult";

export default CopyResult;
